var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { SocialFacebookButton, } from '@stepstone-genesis/components';
import { useLoginWithFacebook } from '../hooks';
import { Logger } from '../../../utils/logger';
const useCallbackRef = (callback) => {
    const callbackRef = useRef(callback);
    useLayoutEffect(() => {
        callbackRef.current = callback;
    }, [callback]);
    return callbackRef;
};
export const FacebookLoginButton = (_a) => {
    var { onSuccess, onError, buttonText, onSendTrackingCallback, consent } = _a, rest = __rest(_a, ["onSuccess", "onError", "buttonText", "onSendTrackingCallback", "consent"]);
    const [shouldDisplay, setShouldDisplay] = useState(false);
    const { login, status, accountWasCreated, email, hasCompleteCv, failureReason, } = useLoginWithFacebook();
    const savedOnSuccess = useCallbackRef(onSuccess);
    const savedOnError = useCallbackRef(onError);
    const isLoading = status === 'loading';
    const isDisabled = status === 'initialising' || status === 'initialisationFailed';
    const handleClick = () => {
        onSendTrackingCallback('buttonClick');
        login(consent);
    };
    useEffect(() => {
        Logger.log('Status: %s', status);
        if (status !== 'awaitingConsent') {
            setShouldDisplay(true);
        }
    }, [status]);
    useEffect(() => {
        var _a, _b;
        if (status === 'error') {
            Logger.error('Login with Facebook failed: %s', failureReason);
            failureReason === 'emailNotFound'
                ? onSendTrackingCallback('phoneNumberVerificationError')
                : onSendTrackingCallback('emailVerificationError');
            (_a = savedOnError.current) === null || _a === void 0 ? void 0 : _a.call(savedOnError, { failureReason: failureReason || 'unknown' });
        }
        else if (status === 'success') {
            Logger.info('Login with Facebook succeeded! accountWasCreated: %s, hasCompleteCv: %s', accountWasCreated, hasCompleteCv);
            accountWasCreated
                ? onSendTrackingCallback('registrationSuccess')
                : onSendTrackingCallback('loginSuccess');
            (_b = savedOnSuccess.current) === null || _b === void 0 ? void 0 : _b.call(savedOnSuccess, { accountWasCreated, email, hasCompleteCv });
        }
    }, [
        status,
        failureReason,
        accountWasCreated,
        email,
        hasCompleteCv,
        savedOnSuccess,
        savedOnError,
        consent,
    ]);
    return shouldDisplay ? (React.createElement(SocialFacebookButton, Object.assign({}, rest, { isFullWidth: true, isDisabled: isDisabled, isLoading: isLoading, onClick: handleClick, "data-testid": "facebook-login-button" }), buttonText)) : null;
};
//# sourceMappingURL=FacebookLoginButton.js.map